export class UserProfile {
  readonly username: string;
  readonly name: string;
  readonly roles: string[];
  readonly localRoles: string[];

  constructor(username: string, name: string, roles: string[], localRoles?: string[]) {
    this.username = username;
    this.name = name;
    this.roles = roles || [];
    this.localRoles = localRoles || [];
  }
}
